import { render } from "./EditDureeMedicament.vue?vue&type=template&id=b2b5832a&scoped=true"
import script from "./EditDureeMedicament.vue?vue&type=script&lang=js"
export * from "./EditDureeMedicament.vue?vue&type=script&lang=js"

import "./EditDureeMedicament.vue?vue&type=style&index=0&id=b2b5832a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b5832a"]])

export default __exports__